__turbopack_context__.v({
  "btn": "PlatformsSection-module__0kK6HW__btn",
  "eyebrow": "PlatformsSection-module__0kK6HW__eyebrow",
  "icon": "PlatformsSection-module__0kK6HW__icon",
  "imageFrame": "PlatformsSection-module__0kK6HW__imageFrame",
  "item": "PlatformsSection-module__0kK6HW__item",
  "itemText": "PlatformsSection-module__0kK6HW__itemText",
  "itemTitle": "PlatformsSection-module__0kK6HW__itemTitle",
  "lead": "PlatformsSection-module__0kK6HW__lead",
  "placeholder": "PlatformsSection-module__0kK6HW__placeholder",
  "section": "PlatformsSection-module__0kK6HW__section",
  "title": "PlatformsSection-module__0kK6HW__title",
});
